module.exports = __webpack_public_path__ + "static/media/bg_20.423218b8.png";